// const listArbitorsBody = document.querySelector('#arbitors-body');
const listArbitorsBody = document.querySelector('#arbitors').querySelector('div[name=body]');

import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listArbitorsBody.innerHTML = '';
  },

  getElement(item, index) {
    console.log(window.appSettings.xhrSettings.urlContentFest);
    // let nonephoto = '<img src="../img/photo-none.png">';
    let htmlDesc = `action=edit juryID=${item.id} `;
    let cssIsChairman = '';

    if(item.isChairman)
      cssIsChairman = 'isChairman';
    let linkOnImg = '';
    if(item.image && item.image.length >3)
      linkOnImg = `<img src="${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/jury/${item.image}_preview_300.jpg" ${htmlDesc} class="shimmer">`;
    else
      linkOnImg = `<img src="img/placeholder_jury.jpg" ${htmlDesc}>`;
    // if (item.image && item.image.length > 2) 
      // nonephoto = '<img src="../img/photo-has.png">';
    return `<div class="cardJury ${cssIsChairman} column" ${htmlDesc}>
                      ${linkOnImg}
                      <div  ${htmlDesc} >${item.name}</div>
                    </div>`;

  },

  drawDataInContainer(servAnswer) {
    let oldSection;
    let fullHtml = '';
    if (servAnswer) {
      oldSection = -99;
     
      servAnswer.forEach((item, index) => {
        if(oldSection != item.catID){
          let upDisabled = '';
          let downDisabled = '';
          if(index  === 0)
            upDisabled = ' disabled = "true"';
          else if(index === (servAnswer.length - 1))
            downDisabled = ' disabled = "true"';

          oldSection = item.catID;
          // console.log(item);
          if(fullHtml.length > 4)
            fullHtml += `</div></div>`;
          fullHtml += ` <div class = "block_items ${(item.hidden) ? "hiddenElement":"g"}">
            <div class="row jury_section_name m-1 p-0   "> 
              <b>${item.catName} </b> 
              <button  class="btn btn-success p-0 icon-btn icon-btn__up_down " action=up ${upDisabled} catID=${item.catID} catName = \"${item.catName}\">></button>
              <button  class="btn btn-success p-0 icon-btn icon-btn__up_down " action=down ${downDisabled} catID=${item.catID} catName = \"${item.catName}\"><</button>
             
              <button  class="btn btn-success p-0 icon-btn icon-btn__edit" action=rename catID=${item.catID} catName = \"${item.catName}\"></button>
              <button  class="btn btn-success p-0 icon-btn icon-btn__delete--red"  action=delete catID=${item.catID} catName = \"${item.catName}\""></button>
            </div>
            <div class = "row p-1 jury_section_body">
           `;
        }
        if (item.jury) 
          item.jury.forEach((jury, index) => {
           fullHtml += this.getElement(jury, index);
          });


        fullHtml += `<div class="cardJuryCircle card_add " action=new catID=${item.catID}>
                      <h1 action=new  catID=${item.catID} >+</h1>
                    </div>`;
        // fullHtml += `</div>`;
                      // <h6 action=new  catID=${item.catID} >Добавить</h6>
        // listArbitorsBody.insertAdjacentHTML('beforeend', this.getElement(item, index))
      });

      fullHtml += `</div></div>`;
      listArbitorsBody.innerHTML = fullHtml;

    } else 
      listArbitorsBody.innerHTML = 'Секций жюри не обнаружено!'
  },

  drawMarkupInContainer(markup) {
    listArbitorsBody.insertAdjacentHTML('beforeend', markup);
  },

};
